import React, { ChangeEvent } from 'react'

import * as Styled from './InputRadio.styled'

type Props = {
  name: string
  value: string
  checked: boolean
  label: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const InputRadio = ({ name, value, checked, label, onChange }: Props) => {
  return (
    <Styled.Label>
      <Styled.Input checked={checked} type="radio" name={name} value={value} onChange={onChange} />
      <Styled.Indicator>{label}</Styled.Indicator>
    </Styled.Label>
  )
}

export default InputRadio
